import './ShortlistBtn.css';
import React, { useEffect } from 'react';
import { canUseDOM, get, getPageThemeColors } from '../../../utils';
import { deleteVenuesApi, saveVenuesApi } from '../../../utils/venues';
import { tealiumClickFunc, tealiumMergeClickData } from '../../../utils/tealium';
const ShortlistBtn = _ref => {
  let {
    checked,
    id,
    sitecoreContext,
    title,
    analytics,
    params,
    dynamicColor,
    dynamicColorActive
  } = _ref;
  id = id.toLowerCase();
  const [isVdsite, setIsVdsite] = React.useState(true);
  React.useEffect(() => {
    if (canUseDOM && !document.body.classList.contains('vdsite')) {
      setIsVdsite(false);
    }
  }, []);
  const primaryPageThemeColor = get(sitecoreContext, 'themesOfPage.primary');
  const primaryActivePageThemeColor = get(sitecoreContext, 'themesOfPage.primary_active');
  const selectedPrimaryColor = primaryPageThemeColor ? primaryPageThemeColor : getPageThemeColors(isVdsite).primary;
  const selectedActivePrimaryColor = primaryActivePageThemeColor ? primaryActivePageThemeColor : getPageThemeColors(isVdsite).primary_active;
  if (canUseDOM && !checked) {
    const ids = JSON.parse(localStorage.getItem('shortlistVenues') || '[]');
    checked = ids.some(itemId => itemId === id);
  }
  const [isChecked, setChecked] = React.useState(checked);
  useEffect(() => {
    if (canUseDOM) {
      const triggerUpdate = () => {
        const svids = JSON.parse(localStorage.getItem('shortlistVenues') || '[]');
        setChecked(svids.some(svid => svid === id));
      };
      triggerUpdate();
      document.body.addEventListener('shortlistVenues', triggerUpdate);
      return () => {
        document.body.removeEventListener('shortlistVenues', triggerUpdate);
      };
    }
  }, [isChecked]);
  const onChange = event => {
    setChecked(!isChecked);
    if (!isChecked) {
      if (analytics.add) {
        tealiumClickFunc(tealiumMergeClickData(analytics.add, params || {}), title);
      }
    } else {
      if (analytics.remove) {
        tealiumClickFunc(tealiumMergeClickData(analytics.remove, params || {}), title);
      }
    }
    if (canUseDOM) {
      let ids = JSON.parse(localStorage.getItem('shortlistVenues') || '[]');
      const ok = () => {
        localStorage.setItem('shortlistVenues', JSON.stringify(ids));
        document.body.dispatchEvent(new Event('shortlistVenues'));
      };
      if (!isChecked) {
        if (!ids.some(sv => sv === id)) {
          saveVenuesApi(sitecoreContext, [id]).then(response => {
            if (!response || !response.errors) {
              ids.push(id);
              ok();
            } else {
              setChecked(false);
            }
          });
        }
      } else {
        ids = ids.filter(sv => sv !== id);
        deleteVenuesApi(sitecoreContext, [id]).then(response => {
          if (!response || !response.errors) {
            ok();
          } else {
            setChecked(true);
          }
        });
      }
    }
  };
  const variables = {
    "--shortlist-btn-primary-color": dynamicColor ? dynamicColor : selectedPrimaryColor,
    "--shortlist-btn-active-color": dynamicColorActive ? dynamicColorActive : selectedActivePrimaryColor
  };
  return /*#__PURE__*/React.createElement("div", {
    className: `${commonStyles} article__icon shortlist__icon`,
    style: variables
  }, /*#__PURE__*/React.createElement("label", {
    className: "my-icon-white",
    tabIndex: 0,
    onKeyPress: event => {
      if (event.key === "Enter" || event.key === "NumpadEnter" || event.which === 32) {
        event.preventDefault();
        event.target.click();
      }
    }
  }, /*#__PURE__*/React.createElement("input", {
    type: "checkbox",
    checked: isChecked,
    onChange: onChange,
    onTouchEnd: e => e.preventDefault(),
    tabIndex: -1
  }), /*#__PURE__*/React.createElement("svg", {
    className: "my-icon-white__svg-first",
    xmlns: "http://www.w3.org/2000/svg",
    width: "15.046",
    height: "21.797",
    viewBox: "0 0 15.046 21.797"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-25.2 -17.2)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 504",
    transform: "translate(25.6 17.6)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 502"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 146",
    d: "M39.408,38.582a.5.5,0,0,1-.2-.065l-6.481-5.69-6.481,5.69a.365.365,0,0,1-.438,0,.452.452,0,0,1-.2-.421V20.385A2.659,2.659,0,0,1,28.111,17.6h9.225a2.658,2.658,0,0,1,2.511,2.785V38.1a.572.572,0,0,1-.2.421A.633.633,0,0,1,39.408,38.582Zm-6.685-6.791a.392.392,0,0,1,.2.065l6.043,5.431v-16.9a1.728,1.728,0,0,0-1.635-1.813H28.111a1.728,1.728,0,0,0-1.635,1.813v16.9l6.043-5.431A.392.392,0,0,1,32.723,31.791Z",
    transform: "translate(-25.6 -17.6)",
    fill: "#007cba",
    stroke: "#007cba",
    "stroke-width": "0.8"
  }))))), /*#__PURE__*/React.createElement("svg", {
    className: "my-icon-white__svg-second",
    xmlns: "http://www.w3.org/2000/svg",
    width: "15.046",
    height: "21.797",
    viewBox: "0 0 15.046 21.797"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-25.2 -17.2)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 504",
    transform: "translate(25.6 17.6)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 502"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 146",
    d: "M39.408,38.582a.5.5,0,0,1-.2-.065l-6.481-5.69-6.481,5.69a.365.365,0,0,1-.438,0,.452.452,0,0,1-.2-.421V20.385A2.659,2.659,0,0,1,28.111,17.6h9.225a2.658,2.658,0,0,1,2.511,2.785V38.1a.572.572,0,0,1-.2.421A.633.633,0,0,1,39.408,38.582Z",
    transform: "translate(-25.6 -17.6)",
    "stroke-width": "0.8"
  })))))));
};
const commonStyles = "cjq8uwa";
export default ShortlistBtn;